import { NetworkFields } from '@tribeplatform/gql-client/graphql'
import { Image } from '@tribeplatform/gql-client/types'

import type { ComposerExtensionConfig } from '../Composer/@types/index.js'

export const MARK_MESSAGING_SPACE_AS_VIEWED_AFTER_MS = 100

export const NEW_CHAT_MEMBERS_COUNT_LIMIT = 10

export const ChatComposerExtensionConfig: ComposerExtensionConfig = {
  heading: false,
  mention: false,
  emoji: true,
  embed: false,
  attachment: false,
  image: false,
  video: false,
  code: true,
  list: false,
  table: false,
  tableOfContents: false,
  formatting: {
    bold: false,
    italic: true,
    underline: true,
    strikethrough: true,
  },
  poll: false,
}

export const networkFields: NetworkFields = {
  settings: 'basic',
}

export const defaultGroupChatAvatar = {
  url: 'https://tribe-s3-production.imgix.net/e5fFA3ZY4hNPgYjAyzGHq?auto=compress,format&dl',
} as Image
